<template>
  <div class="m_showBox"
       :class="skin">
    <div class="showBox_mask"></div>
    <div class="loading_wrap"
         v-if="buttonstatus === 1"></div>
    <div class="pop_box"
         id="pox-box"
         v-width="widthData"
         v-drag>
      <p class="pop_box_title">
        {{title}}
        <span class="pop_box_close"
              @click="cancel"></span>
      </p>
      <div class="pop_box_content">
        <slot></slot>
      </div>
      <div class="pop_box_bottom">
        <a href="javascript:;"
           class="cancel_btn"
           @click="cancel"
           v-show="!hiddenCancel">{{canceltext}}</a>
        <a href="javascript:;"
           class="confirm_btn"
           :class="{widths: buttonstatus === 1}"
           @click="confirm"
           v-show="!hiddenConfirm">
          <svg viewBox="25 25 50 50"
               class="u-circular"
               v-if="buttonstatus === 1">
            <circle cx="50"
                    cy="50"
                    r="20"
                    fill="none"
                    class="path"></circle>
          </svg>
          <span :class="{'marginLeft': buttonstatus === 1}">{{confirmtext || '确定'}}</span>
        </a>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  // 由父组件传入的值
  props: {
    skin: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: "提示"
    },
    hiddenCancel: {
      type: Boolean,
      default: false
    },
    hiddenConfirm: {
      type: Boolean,
      default: false
    },
    confirmtext: {
      type: String,
      default: "确定"
    },
    canceltext: {
      type: String,
      default: "取消"
    },
    buttonstatus: {
      type: Number,
      default: 0
    },
    widthData: {
      type: String,
      default: "550px"
    },
  },
  data: function () {
    return {};
  },
  watch: {},
  mounted: function () {

  },
  methods: {
    cancel: function () {
      this.$emit("cancel");
    },
    confirm: function () {
      if (this.buttonstatus === 1) {
        return;
      }
      this.$emit("confirm");
    },
    toShowModal: function (_b) {
      if (_b) $("#m-dialog-box").modal({ backdrop: "static" });
      else $("#m-dialog-box").modal('hide');
    },
    toHiddenModal: function () {
      $("#m-dialog-box").modal('hide');
    }
  },
  directives: {
    width: {
      bind (el, binding) {
        el.style.width = binding.value
      },
    },
    drag: {
      inserted: function (el, binding, vnode) {
        vnode = vnode.elm;
        el.onmousedown = ((event) => {
          if (event.target.className !== "pop_box_title") {
            return;
          }
          //获取鼠标在盒子中的位置
          let mouseX = event.clientX - vnode.offsetLeft;
          let mouseY = event.clientY - vnode.offsetTop;
          console.log(mouseX, mouseY);
          //绑定移动和停止函数
          document.onmousemove = ((event) => {
            let left, top;
            //获取新的鼠标位置对应下的盒子应该在的位置
            left = event.clientX - mouseX;
            top = event.clientY - mouseY;
            //获取div在页面中X轴的最小最大位置
            let minX = vnode.offsetWidth / 2;
            let maxX = (window.innerWidth - vnode.offsetWidth / 2) - 10//去掉滚动条的宽度
            if (left <= minX) {
              left = minX;
            } else if (left >= maxX) {
              left = maxX;
            }
            //获取div在页面中Y轴的最大最小位置
            let minY = vnode.offsetHeight / 2;
            let maxY = (window.innerHeight - vnode.offsetHeight / 2);
            if (top <= minY) {
              top = minY;
            } else if (top >= maxY) {
              top = maxY;
            }
            //赋值移动
            vnode.style.left = left + 'px';
            vnode.style.top = top + 'px';
          });
          document.onmouseup = (() => {
            document.onmousemove = document.onmouseup = null;
          });
        });
        window.onresize = (() => {
          vnode.style.left = "50%";
          vnode.style.top = "50%";
        });
      }
    }
  }
}
</script>
<style>
.m-drag-title {
  cursor: all-scroll;
}

.m_showBox {
  position: fixed;
  z-index: 9999999;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
}
.loading_wrap {
  position: fixed;
  z-index: 10000000000;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background: transparent;
}
.m_showBox .showBox_mask {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  background-color: #000;
  opacity: 0.5;
}
.pop_box {
  position: absolute;
  width: 550px;
  background: #fff;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.m_showBox .pop_box_content {
  min-height: 80px;
  max-height: calc(100vh - 140px);
  overflow-x: hidden;
  overflow-y: auto;
  position: relative;
  /* padding-top: 24px; */
  /* padding-bottom: 21px; */
}
.m_showBox .pop_box_title {
  cursor: all-scroll;
  word-break: keep-all;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  position: relative;
  top: 0;
  left: 0;
  height: 34px;
  line-height: 34px;
  background: #000;
  color: #fff;
  font-size: 14px;
  font-family: \5fae\8f6f\96c5\9ed1;
  padding: 0 31px 0 18px;
  text-align: left;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  font-weight: bold;
  margin-bottom: 0px;
}
.m_showBox .pop_box_title .pop_box_close {
  cursor: pointer;
  position: absolute;
  top: 50%;
  margin-top: -8px;
  right: 20px;
  width: 16px;
  height: 16px;
  line-height: 999em;
  overflow: hidden;
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAWCAYAAADEtGw7AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA4RpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDowZDJjNDBjNC02YTQ0LThkNDUtOGIwYi0yYzA5NmUyOWU5NDYiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6QzUzRTRDREQ2RDdFMTFFQThERjJBMzhGMzgyRDNCNzYiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6QzUzRTRDREM2RDdFMTFFQThERjJBMzhGMzgyRDNCNzYiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTcgKFdpbmRvd3MpIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6Y2UwZjBhMmUtOTA4ZC1jYjRjLTg2ODQtZjIyNTNjMDc5NGY4IiBzdFJlZjpkb2N1bWVudElEPSJhZG9iZTpkb2NpZDpwaG90b3Nob3A6ZjRlZGI4ZGMtNjgxZi0xMWVhLWFiMjktY2Y5MjQ1OGM2NWFkIi8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+Ho8IBgAAAOZJREFUeNqk1dsKwjAMBuA41qkPKWzog+l0YwNfUDzUBFPQ0UMSC/9F1/VbVxoK3nvA7DBnjOO+JTXmhGmpH9Cb/7TJiBM6sHHHdPD1ILRZidcRY6KBDa/0Z0CIx9ArZhtecAY8hTZhjy14Fl3CUryIxuAcXvF4EU3BAZ8XQI85StAcnFq5CC3BwL/fR9CB9zo5t4J8w0/DM/L8xcnM1J1T8TnXoCPmIi1/TUXRfq+kRaSuKGmFalExbkFFOPBkLVrC18BXkgXNlf9IAx1fJxY0tvIH5hAGWj6nzR+XqeNzvqf+W4ABAHAwBmdo9U19AAAAAElFTkSuQmCC)
    no-repeat;
  background-size: cover;
}
.m_showBox .pop_box_bottom {
  margin: 0;
  /* padding: 16px 0; */
  padding: 0 0 15px 0;
  text-align: center;
  border-top: 1px solid transparent;
}
.pop_box_bottom .cancel_btn {
  display: inline-block;
  min-width: 60px;
  height: 28px;
  line-height: 28px;
  background: #b5b5b5;
  margin: 0 8px;
  padding: 0 15px;
  border: 1px solid #e6e7ec;
  color: #fff;
  text-align: center;
  vertical-align: middle;
  font-size: 14px;
  text-decoration: none;
  border-radius: 3px;
  cursor: pointer;
}
.pop_box_bottom .cancel_btn {
  display: inline-block;
  min-width: 60px;
  height: 25px;
  line-height: 25px;
  background: #b5b5b5;
  margin: 0 8px;
  padding: 0 15px;
  border: 1px solid #e6e7ec;
  color: #fff;
  text-align: center;
  vertical-align: middle;
  font-size: 14px;
  text-decoration: none;
  border-radius: 3px;
  cursor: pointer;
}
.pop_box_bottom .confirm_btn {
  position: relative;
  display: inline-block;
  min-width: 60px;
  height: 24px;
  line-height: 24px;
  background: #ffc107;
  margin: 0 8px;
  padding: 0 15px;
  border: 1px solid #ffc107;
  color: #fff;
  text-align: center;
  vertical-align: middle;
  font-size: 14px;
  text-decoration: none;
  border-radius: 3px;
  cursor: pointer;
}
.pop_box_bottom .cancel_btn:hover {
  background: #a5a2a2;
  border-color: #a5a2a2;
}
.pop_box_bottom .confirm_btn:hover {
  background: #f1b707;
  border-color: #f1b707;
}
.u-circular {
  position: absolute;
  right: 60px;
  top: 4px;
  width: 20px;
  height: 20px;
  animation: loading-rotate 2s linear infinite;
}
.u-circular .path {
  animation: loading-dash 1.5s ease-in-out infinite;
  stroke-dasharray: 90, 150;
  stroke-dashoffset: 0;
  stroke-width: 2;
  stroke: #fff;
  stroke-linecap: round;
}
.pop_box_bottom .confirm_btn .widths {
  width: 70px;
}
.pop_box_bottom .confirm_btn .marginLeft {
  margin-left: 10px;
}
/*skin样式宽度*/
.small .pop_box {
  width: 550px;
}
.middle .pop_box {
  width: 700px;
}
.large .pop_box {
  width: 850px;
}
</style>